// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".client-Components-CidrRanges-CidrRange-module__root--q_zhZ {\n  display: flex;\n}\n/*# sourceMappingURL=CidrRange.module.css.map */", "",{"version":3,"sources":["webpack://./CidrRange.module.less","webpack://./client/Components/CidrRanges/CidrRange.module.less"],"names":[],"mappings":"AAAA;EACC,aAAA;ACCD;AACA,+CAA+C","sourcesContent":[".root {\n\tdisplay: flex;\n}",".root {\n  display: flex;\n}\n/*# sourceMappingURL=CidrRange.module.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "client-Components-CidrRanges-CidrRange-module__root--q_zhZ"
};
export default ___CSS_LOADER_EXPORT___;
